
import React, { useState, useEffect } from 'react';

interface LogoProps {
  className?: string;
  customSrc?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "w-10 h-10", customSrc }) => {
  const [src, setSrc] = useState(customSrc || 'logo.png');
  const [errorCount, setErrorCount] = useState(0);

  useEffect(() => {
    if (customSrc) {
      setSrc(customSrc);
      setErrorCount(0);
    }
  }, [customSrc]);

  const handleImageError = () => {
    if (errorCount === 0) {
      setSrc('logo.png');
      setErrorCount(1);
    } else if (errorCount === 1) {
      // Use a construction-themed fallback icon from a reliable CDN
      setSrc('https://cdn-icons-png.flaticon.com/512/4342/4342134.png');
      setErrorCount(2);
    }
  };

  return (
    <div 
      className={`flex items-center justify-center overflow-hidden shrink-0 ${className}`}
      style={{ 
        maxWidth: '180px', 
        maxHeight: '48px', 
        width: 'auto', 
        height: '48px',
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <img 
        src={src} 
        alt="Sai SSK Logo" 
        className="max-w-full max-h-full object-contain block"
        style={{ 
          maxWidth: '100%', 
          maxHeight: '100%', 
          width: 'auto', 
          height: 'auto' 
        }}
        onError={handleImageError}
      />
    </div>
  );
};

export default Logo;
